module.exports = __webpack_public_path__ + "static/img/u4.63d79e18.png";